/**
 * List of known CIP-30 compatible (or partially compatible) wallets.
 */
export var KnownCip30WalletId;
(function (KnownCip30WalletId) {
    KnownCip30WalletId["Nami"] = "nami";
    KnownCip30WalletId["Eternl"] = "eternl";
    KnownCip30WalletId["TyphonCip30"] = "typhoncip30";
    /**
     * @deprecated
     */
    KnownCip30WalletId["ccvault"] = "ccvault";
    KnownCip30WalletId["Typhon"] = "typhon";
    KnownCip30WalletId["Yoroi"] = "yoroi";
    KnownCip30WalletId["Flint"] = "flint";
    KnownCip30WalletId["Gero"] = "gerowallet";
    KnownCip30WalletId["CardWallet"] = "cardwallet";
    KnownCip30WalletId["NuFi"] = "nufi";
})(KnownCip30WalletId || (KnownCip30WalletId = {}));
//# sourceMappingURL=types.js.map